//export {}; // keerp complier happy while code is disabled

 // appInsights.js
 import { ApplicationInsights } from '@microsoft/applicationinsights-web';
 import { ReactPlugin } from '@microsoft/applicationinsights-react-js';

 let appInsights: ApplicationInsights | null = null;
 const appInsightsReactPlugin = new ReactPlugin();

 const initializeAppInsights = (instrumentationKey: string) => {
     console.log('app insights initializer init with key : ' + instrumentationKey);
     if (!appInsights) {
         appInsights = new ApplicationInsights({
             config: {
                 instrumentationKey: instrumentationKey,
                 extensions: [appInsightsReactPlugin],
             },
         });
         appInsights.loadAppInsights();

     }
 };

 export { appInsights, appInsightsReactPlugin, initializeAppInsights };
